import { useMemo } from 'react';

export default function usePdfNotesIndex({ notes }) {
  const normalizedNotes = useMemo(() => {
    if (!notes || notes.length === 0) return [];

    return notes.map((note) => {
      if (!note) return null;

      let normalizedPosition = null;
      if (note.position) {
        if (typeof note.position === 'object' && note.position.x !== undefined && note.position.y !== undefined) {
          normalizedPosition = { x: note.position.x, y: note.position.y };
        } else if (typeof note.position === 'string') {
          try {
            const parsed = JSON.parse(note.position);
            if (parsed && parsed.x !== undefined && parsed.y !== undefined) {
              normalizedPosition = { x: parsed.x, y: parsed.y };
            }
          } catch {
            // noop
          }
        }
      } else if (note.position_x !== undefined && note.position_y !== undefined) {
        normalizedPosition = { x: note.position_x, y: note.position_y };
      }

      return {
        ...note,
        position: normalizedPosition,
      };
    }).filter((note) => note !== null);
  }, [notes]);

  const pageNotesMap = useMemo(() => {
    const map = {};
    normalizedNotes.forEach((note) => {
      const notePage = typeof note.page_number === 'string' ? parseInt(note.page_number, 10) : note.page_number;
      const hasValidPosition = note.position &&
        typeof note.position === 'object' &&
        note.position.x !== undefined &&
        note.position.y !== undefined;

      if (hasValidPosition && notePage) {
        if (!map[notePage]) {
          map[notePage] = [];
        }
        map[notePage].push(note);
      }
    });
    return map;
  }, [normalizedNotes]);

  return { normalizedNotes, pageNotesMap };
}
